export class ConstantsCpbxApi {
    // relative url > you have to add protocoll and domain (https://<domain>)

    // special case - full url here
    public static readonly EncryptAuthorizationHeaderUrl = "/psa/EncryptAuthorizationHeader/";

    // all variables now ary simple parts of the url which will be set up dynamically
    public static readonly ProxyUrl: string = "/psa/cpbxapi/v2.0";
    public static readonly PartApiPath: string = "/com.broadsoft.xsi-actions/v2.0";
    public static readonly Part1User: string = "/user";

    public static readonly Part3Profile: string = "/profile";
    public static readonly Part3Services: string = "/services";
    public static readonly Part3Directories: string = "/directories";
    public static readonly Part3Calls: string = "/calls";

    public static readonly Part4CallingLineIDDeliveryBlocking: string = "/CallingLineIDDeliveryBlocking";
    public static readonly Part4DoNotDisturb: string = "/DoNotDisturb";
    public static readonly Part4Enterprise: string = "/Enterprise";
    public static readonly Part4DirectedCallPickup: string = "/DirectedCallPickup";
    public static readonly Part4CallRetrieve: string = "/CallRetrieve";
    public static readonly Part4LastNumberRedial: string = "/LastNumberRedial";
    public static readonly Part4CallPickup: string = "/CallPickup";
    public static readonly Part4IntegratedIMP: string = "/IntegratedIMP";

    public static readonly QueryFormatAsJson: string = "?format=json";
}
